export const OPTHINES = {
  voteName: 'composition',
  // 此类型活动只需要更改aid, tid
  aid: '16',
  tid: '281',
  mustSearch: 'Button',
  buttonBg: '#07C160',
  title: '天地大课堂 活动中成长',
  subtitle: '树人学子六年间必写文章',
  themeColor: {
    activeBgColor: '#07C160',
    inactiveBgColor: '#eeeeee',
  },
  tabs: [
    {
      tabName: '活动首页',
      tabPath: '/2022TDDKT/First',
    },
    {
      tabName: '我要投稿',
      tabPath: '/2022TDDKT/User',
    },
  ],
  Grades: [
    '一年级',
    '二年级',
    '三年级',
    '四年级',
    '五年级',
    '六年级',
    '初一',
    '初二',
    '初三',
    '高一',
    '高二',
    '高三',
    '大一',
    '大二',
    '大三',
    '大四',
  ],
};
